import React from 'react';
import PropTypes from 'prop-types';
import InfoMessage from './InfoMessage';
import { formatDate } from '../ContratFunctions.js'

const ConsultationAll = ({ contrats, openModal }) => {
    // Vérifier que les contrats sont un objet et contiennent des UGs
    if (typeof contrats !== 'object' || Object.keys(contrats).length === 0) {
        return <p className="text-gray-700">Aucun contrat disponible pour cette vue.</p>;
    }

    return (
        <div className="px-4 space-y-8 lg:px-0">
            <InfoMessage />
            {Object.keys(contrats).map((ug, index) => (
                <div key={ug} className="mb-8">
                    {/* Titre du UG avec une couleur unique */}
                    <h2 className={`text-3xl font-semibold text-white py-2 px-4 rounded-md mb-4 ${index % 2 === 0 ? 'bg-axa-blue-400' : 'bg-sienna-400'}`}>
                        UG : {ug}
                    </h2>
                    {Object.keys(contrats[ug]).map((intermediaire) => (
                        <div key={intermediaire} className="mb-8">
                            <div className="p-6 overflow-hidden bg-white rounded-lg shadow-xl">
                                <h3 className={`text-2xl font-semibold bg-white border-x-4 ${index % 2 === 0 ? 'border-axa-blue-400 text-axa-blue-400' : 'border-sienna-400 text-sienna-400'} py-2 px-4 rounded-md mb-4 shadow`}>
                                    Intermédiaire : {intermediaire}
                                </h3>
                                <table className="min-w-full overflow-hidden rounded-lg shadow-md bg-gray-50">
                                    <thead className="text-center text-gray-800 bg-gray-200">
                                        <tr>
                                            <th className="px-4 py-3">Référence</th>
                                            <th className="px-4 py-3">Nom du Souscripteur</th>
                                            <th className="px-4 py-3">Destination</th>
                                            <th className="px-4 py-3">Date de Départ</th>
                                            <th className="px-4 py-3">Date de Retour</th>
                                            <th className="px-4 py-3">Voyageurs</th>
                                            <th className="px-4 py-3">Tarif TTC (XPF)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contrats[ug][intermediaire].map((contrat) => (
                                            <tr
                                                key={contrat.id}
                                                className={`border-t border-gray-200 text-center hover:bg-blue-100 hover:shadow-lg hover:scale-105 transform transition-all cursor-pointer duration-150`}
                                                onClick={() => openModal(contrat)}
                                            >
                                                <td className="px-4 py-2 font-medium text-gray-700">
                                                    {contrat.data.reference}
                                                </td>
                                                <td className="px-4 py-2 font-medium text-gray-700">
                                                    {contrat.data.souscripteur.nomEpouse ? `${contrat.data.souscripteur.nom} ep ${contrat.data.souscripteur.nomEpouse}` : contrat.data.souscripteur.nom} {contrat.data.souscripteur.prenom}
                                                </td>
                                                <td className="px-4 py-2">
                                                    {contrat.data.souscripteur.destination}
                                                </td>
                                                <td className="px-4 py-2">
                                                    {formatDate(contrat.data.souscripteur.dateDepart)}
                                                </td>
                                                <td className="px-4 py-2">
                                                    {formatDate(contrat.data.souscripteur.dateRetour)}
                                                </td>
                                                <td className="px-4 py-2">
                                                    {contrat.data.personnes.length}
                                                </td>
                                                <td className="px-4 py-2">
                                                    {contrat.data.contrat.tarif.totalTTC.toLocaleString('fr-FR', { minimumFractionDigits: 0 })} XPF
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

ConsultationAll.propTypes = {
    contrats: PropTypes.object.isRequired,
    openModal: PropTypes.func.isRequired
};

export default ConsultationAll;
